import { render } from "./CheckoutPage.vue?vue&type=template&id=287fc7d6"
import script from "./CheckoutPage.vue?vue&type=script&lang=ts"
export * from "./CheckoutPage.vue?vue&type=script&lang=ts"
script.render = render

export default script